module.exports = __webpack_public_path__ + "static/media/smsAlert.48c8e9b5.png";